// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container__forum-header[data-v-f27d7536]{display:flex;flex-direction:column;border-bottom:1px solid #d1d2db}.text__forum-topic[data-v-f27d7536]{color:#3b3e66;font-weight:600;font-size:1.25rem}.container__forum-comment-like[data-v-f27d7536]{display:flex;flex-direction:row;gap:0 1rem}", ""]);
// Exports
module.exports = exports;
